import { Component, Injectable, OnInit } from '@angular/core'

@Injectable()
@Component({
    selector: 'soaformagentsigned',
    templateUrl: 'soa-form-email-link-agent-signed.html',

})
export class SOAFormEmailLinkAgentSignedComponent implements OnInit {


    ngOnInit() {

    }

}
